import HomePage from "./pages";

export { HomePage };
